// extracted by mini-css-extract-plugin
export default {"container":"EmailBadges_container__e7hUs","badge":"EmailBadges_badge__DccPT","empty":"EmailBadges_empty__cYV73","email":"EmailBadges_email__9c2JF","cross":"EmailBadges_cross__yp0Pv"};